import { CancelablePromise } from '../CancelablePromise';
export function retryCancelablePromise(run, options) {
    var _a, _b, _c, _d;
    const retries = (_a = options === null || options === void 0 ? void 0 : options.retries) !== null && _a !== void 0 ? _a : 0;
    const delay = (_b = options === null || options === void 0 ? void 0 : options.retryDelay) !== null && _b !== void 0 ? _b : 1000;
    const retryOn = (_c = options === null || options === void 0 ? void 0 : options.retryOn) !== null && _c !== void 0 ? _c : (err => err.status >= 500);
    const strategy = (_d = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _d !== void 0 ? _d : 'none';
    return new CancelablePromise((resolve, reject, onCancel) => {
        let attempt = 0;
        let canceled = false;
        let currentPromise = null;
        let timeout = null;
        onCancel(() => {
            canceled = true;
            if (timeout) {
                clearTimeout(timeout);
            }
            if (currentPromise) {
                currentPromise.cancel();
            }
        });
        const execute = () => {
            if (canceled)
                return;
            currentPromise = run();
            currentPromise
                .then(resolve)
                .catch((error) => {
                if (canceled)
                    return;
                if (attempt < retries && retryOn(error)) {
                    attempt++;
                    timeout = setTimeout(execute, getRetryDelay(attempt, strategy, delay));
                }
                else {
                    reject(error);
                }
            });
        };
        execute();
    });
}
function getRetryDelay(attempt, strategy, delay) {
    switch (strategy) {
        // Retry with a fixed delay
        case 'fixed':
            return delay;
        // Retry with an exponential delay
        case 'exponential':
            return delay * Math.pow(2, attempt - 1);
        // retry immediately
        case 'none':
        default:
            return 0;
    }
}
//# sourceMappingURL=retryCancelablePromise.js.map